export default function ReminderOpenBurning() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseReminderOpenBurning">
          <i className="fa-solid fa-fire fa-2xl feature-icon af-icon"></i>
          <b>
            REMINDER from the Fire Marshal&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />
            Open Burning
          </b>
          <span className="badge text-bg-warning">SAFETY</span>
        </button>
      </h2>
      <div id="collapseReminderOpenBurning" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
          
            <ul>
              <li>Morrisville Borough Fire Prevention Code prohibits the open burning of any vegetation, yard waste, municipal waste, recyclable materials, garbage, and construction waste. </li>
              <li>Violations of opening burning are subject to the issuance of citations and fines. </li>
              <li>For Additional information please refer to Morrisville Borough Code. Chapter 136 Open Burning.</li>(
              <a href="https://ecode360.com/6869132#6869132" target="_blank" rel="noopener noreferrer">
                https://ecode360.com/6869132#6869132&nbsp;<i className="fa-solid fa-arrow-up-right-from-square fa-sm"></i>
              </a>
              )
              <li>
                136-1 Prohibited acts.
                <ul>
                  <li>
                    It shall be unlawful for any person, firm, partnership, corporation or unincorporated association to burn any leaves, refuse, garbage, waste material, cars, vehicles or parts
                    thereof, or other debris outside of any building at any time within the Borough of Morrisville, Bucks County, Pennsylvania.
                  </li>
                </ul>
              </li>
            </ul>
          
        </div>
      </div>
    </div>
  );
}
